import { IconCheck, IconChevronDown, IconDeviceFloppy, IconEdit, IconMinus, IconTrash, IconArrowsMove } from '@tabler/icons-react';
import React, { useState, useRef, useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from "react-redux";
import {
    createProjectStatus,
    deleteProjectStatus,
    editTask,
    removeSuccessMessage,
    editProjectStatusSortOrder,
} from "../../../../Settings/store/taskSlice";
import { useParams } from "react-router-dom";
import { hasPermission } from "../../../../ui/permissions";
import {
    ActionIcon,
    Box,
    Button,
    ColorInput,
    Grid,
    Popover,
    Text,
    TextInput,
    Title, Tooltip,
    useMantineTheme,
    LoadingOverlay,
    Divider
} from "@mantine/core";
import { useHotkeys } from '@mantine/hooks';
import ProjectSettingsModal from "../../ProjectSettingsModal";
import { modals } from "@mantine/modals";
import { notifications } from "@mantine/notifications";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { translate } from '../../../../../utils/i18n';

const Status = ({ editStatusHandler, status }) => {
    const dispatch = useDispatch();
    const theme = useMantineTheme();
    const id = useParams();
    const projectId = id.id;
    const { loggedUserId } = useSelector((state) => state.auth.user)
    const { loggedInUser } = useSelector((state) => state.auth.session)

    const { projectStatuses, projectInfo } = useSelector((state) => state.settings.task);

    const [newStatus, setNewStatus] = useState('');
    const [newStatusColor, setNewStatusColor] = useState('#346A80');
    const [selectedStatus, setSelectedStatus] = useState(status ? status.id : '');
    const [selectedStatusName, setSelectedStatusName] = useState(status ? status.name : '');
    const [selectedStatusColor, setSelectedStatusColor] = useState(status && status.color_code ? status.color_code : '#000000');
    const [showStatusList, setShowStatusList] = useState(false);
    const [showStatusAddInput, setShowStatusAddInput] = useState(false);
    const [showStatusEditInput, setShowStatusEditInput] = useState(false);
    const selectStatusRef = useRef(null);

    const [isLoading, setIsLoading] = useState(false);
    const [settingsModalOpened, setSettingsModalOpened] = useState(false);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                setShowStatusList(false);
                setShowStatusAddInput(false);
                setShowStatusEditInput(false);
                setNewStatus('');
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    useEffect(() => {
        setSelectedStatus(status ? status.id : '');
        setSelectedStatusName(status ? status.name : '');
        setSelectedStatusColor(status && status.color_code ? status.color_code : '#000000')
    }, [status]);

    useHotkeys([
        ['Escape', () => setShowStatusList(false)]
    ]);

    const handleInputChange = (e) => {
        setNewStatus(e.target.value);
    };

    const handleColorInputChange = (e) => {
        setNewStatusColor(e.target.value);
    };

    const handleStatusListShow = () => {
        setShowStatusList(true);
    };

    const handleAddStatus = () => {
        if (newStatus.trim() !== '' && newStatus !== 'Type name here') {
            const submitData = {
                name: newStatus,
                project_id: projectId,
                color_code: newStatusColor,
                created_by: loggedInUser ? loggedInUser.loggedUserId : loggedUserId
            }
            dispatch(createProjectStatus(submitData))
            setNewStatus('');
        }
        setShowStatusAddInput(false);
    };

    const handleCreateStatus = () => {
        setNewStatus('');
        setShowStatusAddInput(true);
    };

    const [statusId, setStatusId] = useState(null);
    const statusEditHandler = (status) => {
        setShowStatusAddInput(false);
        if (status && status.id) {
            setNewStatus(status.name);
            setNewStatusColor(status.color_code);
            setShowStatusEditInput(true);
            setStatusId(status.id);
        }

    }

    const handleUpdateStatus = () => {
        if (newStatus.trim() !== '' && newStatus !== 'Type name here') {
            const submitData = {
                id: statusId,
                name: newStatus,
                project_id: projectId,
                color_code: newStatusColor,
                created_by: loggedInUser ? loggedInUser.loggedUserId : loggedUserId
            }
            dispatch(createProjectStatus(submitData)).then((response) => {

                if (response.payload && response.payload.data) {
                    const newStatuses = response.payload.data;
                    const status = newStatuses.find(status => status.id === selectedStatus);

                    setSelectedStatus(status ? status.id : '');
                    setSelectedStatusName(status ? status.name : '');
                    setSelectedStatusColor(status && status.color_code ? status.color_code : '#000000');
                    setNewStatus('');
                    setShowStatusEditInput(false);

                    notifications.show({
                        color: theme.primaryColor,
                        title: response.payload.message,
                        icon: <IconCheck />,
                        autoClose: 5000,
                    });
                    const timer = setTimeout(() => {
                        dispatch(removeSuccessMessage());
                    }, 5000);

                    return () => clearTimeout(timer);

                }

            })
        }
    };

    const handleSelectStatus = (status) => {
        if (status) {
            editStatusHandler(status);
        }
        setSelectedStatus(status ? status.id : '');
        setSelectedStatusName(status ? status.name : '');
        setSelectedStatusColor(status && status.color_code ? status.color_code : '#000000');
        setShowStatusAddInput(false);
        setShowStatusList(false);
    };

    const statusDeleteHandler = () => modals.openConfirmModal({
        title: (
            <Title order={5}>You are parmanently deleting this status</Title>
        ),
        size: 'sm',
        radius: 'md',
        withCloseButton: false,
        children: (
            <Text size="sm">
                Are you sure you want to delete this status?
            </Text>
        ),
        labels: { confirm: translate('Confirm'), cancel: translate('Cancel') },
        onCancel: () => console.log('Cancel'),
        onConfirm: () => {
            if (statusId && projectId) {

                dispatch(deleteProjectStatus({ data: { id: statusId, taskId: null, project_id: projectId } })).then((response) => {

                    if (response.payload && response.payload.status === 200) {

                        const newStatuses = response.payload.data;
                        const foundStatus = newStatuses.find(s => s.id === selectedStatus);

                        setSelectedStatus(foundStatus ? foundStatus.id : '');

                        notifications.show({
                            color: theme.primaryColor,
                            title: response.payload.message,
                            icon: <IconCheck />,
                            autoClose: 5000,
                        });
                        const timer = setTimeout(() => {
                            dispatch(removeSuccessMessage());
                        }, 3000);

                        return () => clearTimeout(timer);

                    } else {
                        modals.open({
                            withCloseButton: false,
                            centered: true,
                            children: (
                                <Fragment>
                                    <Text size="sm">
                                        {response.payload.message}
                                    </Text>
                                    <div className="!grid w-full !justify-items-center">
                                        <Button justify="center" onClick={() => modals.closeAll()} mt="md">
                                            Ok
                                        </Button>
                                    </div>
                                </Fragment>
                            ),
                        });

                    }
                });

            }
        },
    });

    const handleDragEnd = (result) => {
        if (!result.destination) return;
        setIsLoading(true);

        const reorderedStatuses = Array.from(projectStatuses);
        const [movedItem] = reorderedStatuses.splice(result.source.index, 1);
        reorderedStatuses.splice(result.destination.index, 0, movedItem);
        if (result.type === 'status') {

            dispatch(editProjectStatusSortOrder({
                data: {
                    project_id: projectId,
                    sort_order: reorderedStatuses.map((status, index) => ({
                        id: status.id,
                        sort_order: index + 1,
                    })),
                },
            })).then((response) => {
                if (response.payload && response.payload.status === 200) {
                    notifications.show({
                        color: theme.primaryColor,
                        title: response.payload.message,
                        icon: <IconCheck />,
                        autoClose: 5000,
                    });
                }
            })
                .finally(() => {
                    setIsLoading(false);
                });
        } else {
            setIsLoading(false);
        }


    };

    return (
        <Fragment>
            <Popover
                opened={showStatusList}
                onClose={() => setShowStatusList(false)}
                width={250}
                position="bottom"
                withArrow
                shadow="md"
                withinPortal={false}
            >
                <Popover.Target>
                    <Tooltip label={translate('Status')} position="top" withArrow>
                        {!selectedStatus ? (
                            <Box onClick={handleStatusListShow} className="w-[115px] justify-center h-[28px] py-0 items-center gap-1.5 inline-flex border border-gray-200 rounded-full bg-gray-50 px-3 cursor-pointer hover:bg-gray-100 transition-colors">
                                <div className="w-1.5 h-1.5 rounded-full bg-gray-400 flex-shrink-0"></div>
                                <Text size="sm" fw={400} c="dimmed" className="whitespace-nowrap flex-grow text-center">Set Status</Text>
                                <IconChevronDown color="#9CA3AF" size="16" className="flex-shrink-0" />
                            </Box>
                        ) : (
                            <Box
                                onClick={handleStatusListShow}
                                style={{ backgroundColor: `${selectedStatusColor}15`, border: `1px solid ${selectedStatusColor}30`, height: '28px' }}
                                className="w-[115px] px-3 py-0 rounded-full items-center justify-between gap-1.5 inline-flex cursor-pointer hover:opacity-80 transition-opacity"
                            >
                                <div className="flex items-center gap-1.5 overflow-hidden">
                                    <div className="w-1.5 h-1.5 flex-shrink-0 rounded-full" style={{ backgroundColor: selectedStatusColor }}></div>
                                    <Text
                                        className="truncate"
                                        c={selectedStatusColor}
                                        size="sm"
                                        fw={400}
                                        title={selectedStatusName}
                                    >
                                        {selectedStatusName}
                                    </Text>
                                </div>
                                <IconChevronDown color={selectedStatusColor} size="16" opacity={0.7} className="flex-shrink-0" />
                            </Box>
                        )}
                    </Tooltip>
                </Popover.Target>
                <Popover.Dropdown>
                    <Box ref={selectStatusRef}>
                        <LoadingOverlay visible={isLoading} zIndex={1000} overlayBlur={2} />
                        <DragDropContext
                            onDragEnd={(result) => {
                                handleDragEnd(result);
                            }}
                        >
                            <Droppable droppableId="statusList" type="status">
                                {(provided) => (
                                    <Box
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                    >
                                        {projectStatuses &&
                                            projectStatuses.map((status, index) => (
                                                <Draggable key={status.id} draggableId={status.id.toString()} index={index} isDragDisabled={true}>
                                                    {(provided) => (
                                                        <Box
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                        >

                                                            {/* Status content */}
                                                            <Grid columns={12} className="hover:bg-[#ebf1f4]">
                                                                <Grid.Col span={9} className="!py-1">
                                                                    <Box
                                                                        className="flex items-center gap-2 w-full cursor-pointer text-[12px] p-1"
                                                                        onClick={() => handleSelectStatus(status)}
                                                                    >
                                                                        {selectedStatus === status.id ? <IconCheck size="14" /> : null}
                                                                        <Box
                                                                            className="flex-shrink-0 w-5 h-5 rounded-full"
                                                                            style={{ backgroundColor: status.color_code }}
                                                                        />
                                                                        <Text lineClamp={1} c="black" size="xs" fw={400} className="flex-grow">
                                                                            {status.name}
                                                                        </Text>
                                                                    </Box>
                                                                </Grid.Col>
                                                            </Grid>

                                                        </Box>
                                                    )}
                                                </Draggable>
                                            ))}
                                        {provided.placeholder}
                                    </Box>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </Box>
                    <Divider my="sm" className="opacity-50" />
                    <Box px="xs" pb="xs">
                        <Button
                            variant="subtle"
                            color="gray"
                            fullWidth
                            size="xs"
                            radius="md"
                            onClick={() => {
                                setSettingsModalOpened(true);
                                setShowStatusList(false);
                            }}
                            styles={(theme) => ({
                                root: {
                                    justifyContent: 'flex-start',
                                    fontWeight: 500,
                                    color: theme.colors.gray[7],
                                    '&:hover': {
                                        backgroundColor: theme.colors.gray[0],
                                    },
                                }
                            })}
                        >
                            Add/Edit Status
                        </Button>
                    </Box>
                </Popover.Dropdown>
            </Popover>

            {settingsModalOpened && (
                <ProjectSettingsModal
                    project_id={projectId}
                    opened={settingsModalOpened}
                    onClose={() => setSettingsModalOpened(false)}
                    isSettings={true}
                />
            )}
        </Fragment>
    );
};

export default Status;
